// These is an issue with the installed version of gatsby-source-datocms, whereby the srcSet image URLs are all the maximum width (https://github.com/datocms/gatsby-source-datocms/issues/99). This is a workaround to generate a responsive srcSet using the available data queried from DatoCMS.

/**
 * @param {Object} fluid - The original DatoCMS fluid object.
 * @param {number[]} widths - Desired widths for srcSet.
 * @returns {Object} - New fluid object with responsive srcSet.
 */
export const updateFluidSrcSetData = (
  fluid,
  widths = [320, 480, 768, 1024, 1600, 2000, 2400, 3200, 4000],
) => {
  if (!fluid || !fluid.src) return fluid;

  // Remove any existing w= param from the query string
  const url = new URL(fluid.src);
  url.searchParams.delete('w');

  // Rebuild base URL with all other params
  const baseUrl = url.origin + url.pathname + (url.search ? `${url.search}&` : '?');
  const cleanBase = baseUrl.replace(/[&?]$/, '');

  // Generate new srcSet
  const newSrcSet = widths
    .map((width) => `${cleanBase}${cleanBase.includes('?') ? '&' : '?'}w=${width} ${width}w`)
    .join(', ');

  // Return a new fluid object with the updated srcSet
  return {
    ...fluid,
    srcSet: newSrcSet,
  };
};
